export default __webpack_public_path__ + "static/media/RangeBadge2.196262bd.png";